import React, {PropTypes as T} from 'react';

const Close2Icon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Close Icon"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__close2 ${className}`}>
    <path d="M6 4.435L1.565 0 0 1.565 4.435 6 0 10.435 1.565 12 6 7.565 10.435
      12 12 10.435 7.565 6 12 1.565 10.435 0 6 4.435z" />
  </svg>
);

Close2Icon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  Close2Icon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_close2.js